<div class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="grid grid-cols-[1fr_1fr_1.4fr_1.6fr_auto] bg-gray-50 px-4 py-3 text-[13px] font-semibold text-gray-600">
    <span>{{ isArabic() ? "الحالة" : "Status" }}</span>
    <span>{{ isArabic() ? "الكمية" : "Quantity" }}</span>
    <span>{{ isArabic() ? "السبب" : "Reason" }}</span>
    <span>{{ isArabic() ? "أخرى" : "Other" }}</span>
    <span></span>
  </div>

  <div class="grid grid-cols-[1fr_1fr_1.4fr_1.6fr_auto] items-center border-t border-gray-100 px-4 py-3.5">
    <span>
      <span class="inline-block rounded-md bg-emerald-50 px-3 py-1 text-[12px] font-bold text-emerald-700">
        {{ fulfilledLabel() }}
      </span>
    </span>
    <span>
      <input
        type="text"
        [value]="fulfilledQuantity()"
        disabled
        class="w-16 rounded-lg border border-gray-200 bg-gray-50 px-2.5 py-1.5 text-center text-[13px] font-bold text-gray-700" />
    </span>
    <span class="text-gray-300">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </span>
    <span class="text-gray-300">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </span>
    <span></span>
  </div>

  @for (row of notFulfilledRows(); track row.rowId) {
    <div class="grid grid-cols-[1fr_1fr_1.4fr_1.6fr_auto] items-center border-t border-gray-100 px-4 py-3.5">
      <span>
        <span class="inline-block rounded-md bg-red-50 px-3 py-1 text-[12px] font-bold text-red-600">
          {{ notFulfilledLabel() }}
        </span>
      </span>

      <span class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="decreaseRowQty(row.rowId)"
          [disabled]="disabled()"
          class="flex h-6 w-6 items-center justify-center rounded border border-gray-300 text-gray-600 disabled:opacity-40">
          −
        </button>
        <input
          type="text"
          [value]="row.quantity"
          (change)="onQuantityInput(row.rowId, $any($event.target).value)"
          [disabled]="disabled()"
          class="w-10 rounded-md border border-gray-200 px-1 py-1 text-center text-[13px] font-bold" />
        <button
          type="button"
          (click)="increaseRowQty(row.rowId)"
          [disabled]="disabled() || row.quantity >= maxQtyForRow(row.rowId)"
          class="flex h-6 w-6 items-center justify-center rounded border border-gray-300 text-gray-600 disabled:opacity-40">
          +
        </button>
      </span>

      <span class="pr-2">
        <div class="group relative">
          <select
            [ngModel]="row.reasonId"
            (ngModelChange)="onReasonChange(row.rowId, $event)"
            [disabled]="disabled()"
            class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black disabled:bg-gray-50 disabled:text-gray-400 ltr:pr-10 rtl:pl-10">
            <option [ngValue]="null" disabled class="placeholder:text-gray-300">
              {{ isArabic() ? "اختر السبب" : "Select reason" }}
            </option>
            @for (reason of reasons(); track reason.id) {
              <option [ngValue]="reason.id">
                {{ isArabic() ? reason.titleAr || reason.titleEn : reason.titleEn }}
              </option>
            }
          </select>
          <span class="pointer-events-none absolute inset-y-0 flex items-center text-gray-500 ltr:right-3 rtl:left-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
        </div>
      </span>

      <span class="pr-2">
        @if (row.reasonId === otherReasonId()) {
          <input
            type="text"
            [ngModel]="row.otherReason"
            (ngModelChange)="onOtherReasonInput(row.rowId, $event)"
            [disabled]="disabled()"
            [placeholder]="isArabic() ? 'اكتب السبب...' : 'Type reason...'"
            class="w-full rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black" />
        } @else {
          <span class="text-gray-300">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </span>
        }
      </span>

      <span class="flex justify-center">
        @if (!disabled()) {
          <button
            type="button"
            (click)="removeRow(row.rowId)"
            class="flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }
      </span>
    </div>
  }

  @if (canAddRow()) {
    <div class="border-t border-gray-100 bg-gray-50/50 px-4 py-3">
      <button
        type="button"
        (click)="addRow()"
        [title]="isArabic() ? 'إضافة سبب آخر' : 'Add another reason'"
        class="flex h-9 w-9 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 shadow-sm transition-colors hover:border-gray-400 hover:bg-gray-50 hover:text-gray-900">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
    </div>
  }
</div>
